<template>
  <v-dialog
    v-model="isVisible"
    max-width="500"
    class="confirm-dialog__wrapper"
    data-cy="confirm-Modal"
  >
    <v-card>
      <v-card-title class="text-h6">{{ title }}</v-card-title>
      <v-card-text>{{ message }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn variant="flat" color="undo" @click="cancel" data-cy="confirm-cancel-action">{{
          koText
        }}</v-btn>
        <v-btn
          variant="flat"
          color="error"
          @click="confirm"
          :disabled="loading"
          :loading="loading"
          data-cy="confirm-submit-action"
          >{{ okText }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { useConfirm } from "@/store/confirm";
import { computed } from "vue";

const confirmStore = useConfirm();

const isVisible = computed(() => confirmStore.isVisible);
const loading = computed(() => confirmStore.loading);
const title = computed(() => confirmStore.title);
const message = computed(() => confirmStore.message);

const okText = computed(() => confirmStore.okText);
const koText = computed(() => confirmStore.koText);

const confirm = confirmStore.confirm;
const cancel = confirmStore.cancel;
</script>

<style lang="postcss" scoped>
.confirm-dialog__wrapper {
  .v-card-title {
    @apply border-b border-gray-200 py-4 font-poppins font-semibold text-primary-800;
  }
  .v-card-text {
    @apply text-primary-800 !px-4;
  }
  .v-card-actions {
    @apply border-t border-gray-200 py-4;
  }
  .v-btn {
    @apply py-0;
  }
  .btn-annulla {
    @apply border border-primary-500 text-primary-500;
  }
  .btn-confirm {
    @apply bg-red-500 text-white hover:bg-red-700;
  }
}
</style>
